export default __webpack_public_path__ + "static/brand-aaa-logo-colour-pos-a5135a6b58fbc0d848fe75a9055707bf.svg";